import type { ReactElement, ReactNode } from 'react'
import type { BadgeComponentType } from '../badge'

export enum ChipVariant {
  primary = 'primary',
  contrast = 'contrast',
}

export interface ChipProps {
  'aria-label'?: string
  badge?: BadgeComponentType
  children?: ReactNode
  className?: string
  disabled?: boolean
  leadingAccessory?: ReactElement
  onClick?: () => void
  rtl?: boolean
  selected?: boolean
  text?: string
  trailingAccessory?: ReactElement
  variant?: ChipVariantType
}

export type ChipVariantType = `${ChipVariant}`
